import Vue from 'vue'

Vue.directive('disable-all', {
    
  inserted(el, binding) {
  
    if (!!binding.value || false ) {
        return
    }
    
    // Tipos de elementos a tener en cuenta a la hora de añadir el atributo disabled
    const tags = ["input", "textarea", "select"]

    tags.forEach(tagName => {
        let nodes = Array.from(el.getElementsByTagName(tagName));
        nodes.forEach(node => {
        node.disabled = true
        })
    })

  }

})